module.exports = __webpack_public_path__ + "media/images/dish-2-b45bbdd7adf3dfb7d1073d9fc9ca51c5.webp";